import React, { useMemo, useState, useEffect } from "react";
import { Row, Col, Spin, Form, Input, Checkbox } from "antd";

import { Link, useHistory, useLocation } from "react-router-dom";
import CarListTable from "./overview/CarsTable";
import { PageHeader } from "../../components/page-headers/page-headers";
import { Main, CardToolbox, BasicFormWrapper } from "../styled";

import { AutoComplete } from "../../components/autoComplete/autoComplete";
import { PanelFiltrov } from "../../components/filtre/panelFiltrov";
import { Button } from "../../components/buttons/buttons";
import { AddUser } from "../pages/style";

import { useMutation, useQuery } from "@apollo/client";
import { ADD_CAR } from "../../graphql/AdminMutations";
import { GET_CARS_PAGINATED } from "../../graphql/AdminQueries";

import { Modal } from "../../components/modals/antd-modals";

// import { SelectCompany } from '../../components/customSelect/selectCompany'
import { SelectCompanyForNewCar } from "../../components/customSelect/selectCompanyForNewCar";
import { SelectCarOwner } from "../../components/customSelect/selectOwner";
import { SelectCarRenter } from "../../components/customSelect/selectRenter";

import { useDispatch, useSelector } from "react-redux";
import {
  setTableCars,
  addCar,
  setNewCarDataSelect,
} from "../../redux/cars/actionCreator";
import { GetSelectData } from "./newCarDataQueries";
import { getItem } from "../../utility/localStorageControl";

import { useTranslation } from "react-i18next";
import displayNotification from "../reservation/admin/notification/notification";
import { zUrl, doUrl } from "../../utils/stavVUrl";
import { useZdrzanie, usePoZmene } from "../../utils/zdrzanie";

// pevnaPobocka: ked je zoznam vlozeny do detailu pobocky, ukazuje len jej
// vozidla a filter pobocky sa nezobrazuje, aby sa nedal prepnut inam.
// Co sa pamata v adrese zoznamu (filtre, hladanie, strana).
const POPIS_URL = {
  hladanie: "text",
  strana: "cislo",
  naStranu: "cislo",
  branchOffice: "cislo",
  carOwnerId: "cislo",
  carRenterId: "cislo",
  storageStatus: "ano/nie",
  storageSeason: "text",
  storageDiskType: "text",
  obdobieSkladu: "obdobie",
  maKontakt: "ano/nie",
  maVin: "ano/nie",
};

const CarList = ({ active, pevnaPobocka }) => {
  const { t } = useTranslation("common");
  const dispatch = useDispatch();
  const history = useHistory();
  const location = useLocation();
  // Zoznam vlozeny do detailu pobocky si adresu neprepisuje.
  const pamatajVUrl = !pevnaPobocka;
  const zoZaciatku = pamatajVUrl ? zUrl(location.search, POPIS_URL) : {};
  const graphqlVariables = {
    tokenGet: process.env.REACT_APP_TOKEN_GET,
    tokenMutation: process.env.REACT_APP_TOKEN_MUTATION,
  };

  const [state, setState] = useState({
    selectedRowKeys: 0,
    selectedRows: 0,
    addVisible: false,
  });

  const [form] = Form.useForm();

  const [branchOficcesData, setBranchOficcesData] = useState([]);
  const [carOwnersData, setCarOwnersData] = useState([]);
  const [carRentersData, setCarRentersData] = useState([]);
  const [loadingList, setLoadingList] = useState(true);
  const [total, setTotal] = useState(0);
  const [pageNumberToGrid, setPageNumberToGrid] = useState(zoZaciatku.strana || 1);
  const [limit, setLimit] = useState(zoZaciatku.naStranu || 20);
  // Do policka sa pise bez obmedzenia, na server ide jeden dopyt az potom,
  // co clovek na chvilu prestane pisat.
  const [searchText, setSearchText] = useState(zoZaciatku.hladanie || "");
  const hladanyText = useZdrzanie(searchText, 300);
  const [filtre, setFiltre] = useState({
    branchOffice: zoZaciatku.branchOffice,
    carOwnerId: zoZaciatku.carOwnerId,
    carRenterId: zoZaciatku.carRenterId,
    storageStatus: zoZaciatku.storageStatus,
    storageSeason: zoZaciatku.storageSeason,
    storageDiskType: zoZaciatku.storageDiskType,
    obdobieSkladu: zoZaciatku.obdobieSkladu,
    maKontakt: zoZaciatku.maKontakt,
    maVin: zoZaciatku.maVin,
  });

  // Adresu prepisujeme bez pridavania do historie, aby krok spat viedol
  // tam, odkial clovek prisiel, ale uz s nastavenymi filtrami.
  useEffect(() => {
    if (!pamatajVUrl) return;
    const novy = doUrl(
      {
        ...filtre,
        hladanie: hladanyText,
        strana: pageNumberToGrid > 1 ? pageNumberToGrid : undefined,
        naStranu: limit !== 20 ? limit : undefined,
      },
      POPIS_URL
    );
    if (novy !== location.search) {
      history.replace({ pathname: location.pathname, search: novy });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filtre, hladanyText, pageNumberToGrid, limit]);

  const newCarSelectData = useSelector(
    (state) => state?.cars?.newCarSelectData,
  );

  useEffect(() => {
    if (newCarSelectData) {
      setBranchOficcesData(newCarSelectData.branchOfices);
      setCarOwnersData(newCarSelectData.carOwners);
      setCarRentersData(newCarSelectData.carRenters);
    }
  }, [newCarSelectData]);

  const graphQlData = GetSelectData(graphqlVariables, true);
  const branchOfices = graphQlData[0]?.data?.getBranchOficces;
  const carOwners = graphQlData[1]?.data?.getCarOwners;
  const carRenters = graphQlData[2]?.data?.getCarRenters;

  // Build query variables like /admin/service/actions
  const user = getItem("user");
  // Kto nie je spravca, vidi len svoju pobocku, a filter pobocky mu to
  // nesmie obist. Spravca si pobocku vyberie vo filtri.
  const vlastnaPobocka =
    Number(pevnaPobocka) ||
    (Number(user?.role) !== 1 ? Number(user?.branchOffice?.id) || undefined : undefined);
  const queryVariables = {
    tokenGet: graphqlVariables.tokenGet,
    offset: (pageNumberToGrid - 1) * limit,
    limit: limit,
    search: hladanyText || undefined,
    branchOffice: vlastnaPobocka || filtre.branchOffice || undefined,
    carOwnerId: filtre.carOwnerId,
    carRenterId: filtre.carRenterId,
    storageStatus: filtre.storageStatus,
    storageSeason: filtre.storageSeason,
    storageDiskType: filtre.storageDiskType,
    storageFrom:
      filtre.obdobieSkladu && filtre.obdobieSkladu[0]
        ? filtre.obdobieSkladu[0].format("YYYY-MM-DD")
        : undefined,
    storageTo:
      filtre.obdobieSkladu && filtre.obdobieSkladu[1]
        ? filtre.obdobieSkladu[1].format("YYYY-MM-DD")
        : undefined,
    maKontakt: filtre.maKontakt,
    maVin: filtre.maVin,
    active: Boolean(active),
  };

  const { data: carsData, loading: carsLoading, error: carsError } = useQuery(
    GET_CARS_PAGINATED,
    {
      variables: queryVariables,
      fetchPolicy: "network-only",
    },
  );

  const carsPayload = carsData?.getCarsPaginated;
  const carsItems = useMemo(() => {
    return Array.isArray(carsPayload?.items) ? carsPayload.items : [];
  }, [carsPayload]);

  useEffect(() => {
    setLoadingList(Boolean(carsLoading));
  }, [carsLoading]);

  useEffect(() => {
    if (carsError) {
      // Mirror service/actions behavior: keep UI stable; log for debugging
      console.error("Cars query failed", carsError);
    }
  }, [carsError]);

  useEffect(() => {
    if (carsPayload) {
      const nextTotal =
        typeof carsPayload.totalCount === "number"
          ? carsPayload.totalCount
          : carsItems.length;
      setTotal(nextTotal);
      dispatch(setTableCars(carsItems));
      setLoadingList(false);
    }
  }, [carsPayload, carsItems, dispatch]);

  useEffect(() => {
    // Select data is only needed for the "Add car" modal; don't gate the list on it
    if (branchOfices && carOwners && carRenters) {
      dispatch(setNewCarDataSelect({ branchOfices, carOwners, carRenters }));
    }
  }, [branchOfices, carOwners, carRenters, dispatch]);

  // create new car
  const [triggerCreateCar] = useMutation(ADD_CAR, {
    variables: graphqlVariables,
  });

  const handleChangePage = (data) => {
    setLoadingList(true);
    setPageNumberToGrid(data?.pageNumber);
    setLimit(data?.pageSize);
  };

  // Ziadna podmienka na pocet znakov: jedina dvojka musi najst vsetky
  // zaznamy, ktore dvojku obsahuju. Predtym sa pri jednom znaku nestalo nic.
  const handleSearch = (text) => {
    setSearchText(typeof text === "string" ? text : "");
  };

  // Az pri skutocnej zmene hladania, nie pri prvom vykresleni, inak by
  // sa strana z adresy hned po otvoreni zoznamu zhodila na jednotku.
  usePoZmene(hladanyText, () => {
    setPageNumberToGrid(1);
  });

  const naMoznosti = (zoznam) =>
    (Array.isArray(zoznam) ? zoznam : [])
      .map((p) => ({
        hodnota: Number(p.id),
        popis: p.company || `${p.firstname || ""} ${p.lastname || ""}`.trim(),
      }))
      .filter((m) => m.popis)
      .sort((a, b) => a.popis.localeCompare(b.popis, "sk"));

  const anoNie = [
    { hodnota: true, popis: "áno" },
    { hodnota: false, popis: "nie" },
  ];

  const definicieFiltrov = [
    ...(Number(user?.role) === 1 && !pevnaPobocka
      ? [
          {
            kluc: "branchOffice",
            popis: "Pneuservis",
            typ: "vyber",
            sirka: 4,
            moznosti: naMoznosti(branchOfices),
          },
        ]
      : []),
    {
      kluc: "carOwnerId",
      popis: "Majiteľ",
      typ: "vyber",
      sirka: 5,
      moznosti: naMoznosti(carOwners),
    },
    {
      kluc: "carRenterId",
      popis: "Nájomca",
      typ: "vyber",
      sirka: 5,
      moznosti: naMoznosti(carRenters),
    },
    {
      // Pyta sa na skutocne zaznamy v sklade, nie na zaskrtavatko v detaile,
      // ktore si s realitou protireci pri zhruba 2700 autach.
      kluc: "storageStatus",
      popis: "Má pneu v sklade",
      typ: "vyber",
      sirka: 3,
      moznosti: anoNie,
    },
    {
      // Co ma auto prave teraz u nas v sklade. Zimna sada v sklade znamena,
      // ze auto chodi na letnej a pojde sa prezuvat.
      kluc: "storageSeason",
      popis: "Uskladnená sezóna",
      typ: "vyber",
      sirka: 3,
      moznosti: [
        { hodnota: "ZIMA", popis: "ZIMA" },
        { hodnota: "LETO", popis: "LETO" },
      ],
    },
    {
      kluc: "storageDiskType",
      popis: "Disk v sklade",
      typ: "vyber",
      sirka: 3,
      moznosti: [
        { hodnota: "ALU", popis: "ALU" },
        { hodnota: "PLECH", popis: "PLECH" },
        { hodnota: "Bez Disku", popis: "bez disku" },
      ],
    },
    {
      // Bez obdobia sezonny filter klame, vela skladu je davno mrtveho.
      kluc: "obdobieSkladu",
      popis: "Posledné uskladnenie",
      typ: "obdobie",
      sirka: 5,
    },
    {
      kluc: "maKontakt",
      popis: "Telefón alebo e-mail",
      typ: "vyber",
      sirka: 3,
      moznosti: anoNie,
    },
    {
      kluc: "maVin",
      popis: "VIN",
      typ: "vyber",
      sirka: 3,
      moznosti: [
        { hodnota: true, popis: "vyplnený" },
        { hodnota: false, popis: "chýba" },
      ],
    },
  ];

  const zmenFilter = (kluc, hodnota) => {
    setFiltre((predosle) => ({ ...predosle, [kluc]: hodnota }));
    setPageNumberToGrid(1);
    setLoadingList(true);
  };

  const vycistiFiltre = () => {
    setFiltre({
      branchOffice: undefined,
      carOwnerId: undefined,
      carRenterId: undefined,
      storageStatus: undefined,
      storageSeason: undefined,
      storageDiskType: undefined,
      obdobieSkladu: undefined,
      maKontakt: undefined,
      maVin: undefined,
    });
    setPageNumberToGrid(1);
    setLoadingList(true);
  };

  const showModal = () => {
    setState({
      ...state,
      addVisible: true,
    });
  };

  const onCancel = () => {
    setState({
      ...state,
      addVisible: false,
    });
  };

  const handleCancel = () => {
    onCancel();
  };

  const handleOk = (values) => {
    onCancel();
    const variables = {
      ...graphqlVariables,
      licencePlate: values.licence_plate,
      firstname: values.firstname,
      lastname: values.lastname,
      phone: values.phone,
      email: values.email,
      note: values.note,
      sendSms: values.sendSms,
      storage_status: values.storage_status,
      type: values.type,
      vin: values.vin ? String(values.vin).trim().toUpperCase() : undefined,
      branchOffice: parseInt(values.company),
      carOwner: parseInt(values.owner),
      carRenter: parseInt(values.renter),
    };

    triggerCreateCar({ variables }).then(({ data }) => {
      const carResponse = data?.createCar;
      let type = "success";
      const message = t("backend.notifications.update");
      let desc = t("backend.notifications.success.recordCreate");
      if (carResponse[0]) {
        dispatch(addCar(carResponse[0]));
      } else {
        type = "error";
        desc = t("backend.notifications.error.recordCreate");
      }

      displayNotification(type, message, desc);
      setTimeout(function() {
        window.location.reload();
      }, 3000);
    });
  };

  return (
    <>
      <CardToolbox>
        <PageHeader
          ghost
          title={t("car.carList")}
          subTitle={
            <>
              <span className="title-counter">
                {total} {t("car.cars")}{" "}
              </span>
              <AutoComplete
                onSearch={handleSearch}
                placeholder="EČV, VIN, meno vodiča"
                width="100%"
                patterns
              />
            </>
          }
          buttons={[
            <Button
              onClick={showModal}
              className="btn-add_new"
              size="default"
              type="primary"
              key="1"
            >
              {/* <Link to="/admin/users/add-user/info">+ Add New Car</Link> */}
              <Link to="#">{t("common.addRecord")}</Link>
            </Button>,
          ]}
        />
      </CardToolbox>

      <Main>
        <Row gutter={15}>
          <Col md={24}>
            <PanelFiltrov
              filtre={definicieFiltrov}
              hodnoty={filtre}
              onZmena={zmenFilter}
              onVycistit={vycistiFiltre}
            />
          </Col>
        </Row>
        <Row gutter={15}>
          <Col md={24}>
            {/* Spinner len pri prvom nacitani. Pri pisani do hladania
                zoznam zostava na obrazovke a len zosedne, inak cela
                tabulka blikala a mizla pri kazdom pismene. */}
            {loadingList && total === 0 && (
              <div className="spin">
                <Spin />
              </div>
            )}
            {(!loadingList || total > 0) && (
              <CarListTable
                loading={loadingList}
                branchOficcesData={branchOficcesData}
                carOwnersData={carOwnersData}
                carRentersData={carRentersData}
                active={active}
                total={total}
                limit={limit}
                sendPageNumberToGrid={handleChangePage}
                pageNumberToGrid={pageNumberToGrid}
                queryVariables={queryVariables}
              />
            )}
          </Col>
        </Row>
        <Modal
          type="primary"
          title={t("car.carInformation")}
          visible={state.addVisible}
          footer={null}
          onCancel={handleCancel}
          width={600}
        >
          <div className="project-modal">
            <AddUser>
              <BasicFormWrapper>
                <Form form={form} name="contact" onFinish={handleOk}>
                  <Row gutter={15}>
                    <Col md={12} sm={24} xs={24}>
                      <Form.Item
                        label={t("car.licencePlate")}
                        name="licence_plate"
                        rules={[{ required: true }]}
                      >
                        <Input placeholder="SPZ" />
                      </Form.Item>
                      <Form.Item
                        name="company"
                        label={t("car.company")}
                        rules={[{ required: true }]}
                      >
                        <SelectCompanyForNewCar data={branchOficcesData} />
                      </Form.Item>

                      <Form.Item
                        name="owner"
                        label={t("car.owner")}
                        rules={[{ required: true }]}
                      >
                        <SelectCarOwner data={carOwnersData} />
                      </Form.Item>

                      <Form.Item
                        name="renter"
                        label={t("car.renter")}
                        rules={[{ required: true }]}
                      >
                        <SelectCarRenter data={carRentersData} />
                      </Form.Item>
                      <Form.Item
                        label={t("car.sendSms")}
                        name="sendSms"
                        valuePropName="checked"
                      >
                        <Checkbox />
                      </Form.Item>
                      <Form.Item
                        label={t("car.storage_status")}
                        name="storage_status"
                        valuePropName="checked"
                      >
                        <Checkbox />
                      </Form.Item>
                    </Col>
                    <Col md={12} sm={24} xs={24}>
                      <Form.Item
                        label={t("car.driverFirstname")}
                        name="firstname"
                        rules={[{ required: true }]}
                      >
                        <Input placeholder="" />
                      </Form.Item>

                      <Form.Item
                        label={t("car.driverLastname")}
                        name="lastname"
                        rules={[{ required: true }]}
                      >
                        <Input placeholder="" />
                      </Form.Item>
                      <Form.Item
                        label={t("car.driverEmail")}
                        name="email"
                        rules={[
                          {
                            type: "email",
                            message: t("car.validation.wrongEmail"),
                          },
                          {
                            required: true,
                            message: t("car.validation.email"),
                          },
                        ]}
                      >
                        <Input placeholder="" />
                      </Form.Item>
                      <Form.Item
                        label={t("car.driverPhone")}
                        name="phone"
                        rules={[
                          {
                            autoComplete: "off",
                          },
                          // ({ getFieldValue }) => ({
                          //   validator(_, value) {
                          //     const pattern = "^[+]421[0-9]{9}$";
                          //     if (value.match(pattern)) {
                          //       return Promise.resolve();
                          //     }
                          //     return Promise.reject(t("car.validation.phone"));
                          //   },
                          // }),
                        ]}
                        hasFeedback
                      >
                        <Input placeholder="+421xxxxxx" autoComplete="off" />
                      </Form.Item>
                      <Form.Item label={t("car.type")} name="type">
                        <Input placeholder="" />
                      </Form.Item>
                      {/* VIN tu chybal, hoci ho mutacia aj databaza poznaju. */}
                      <Form.Item label={t("car.vin")} name="vin">
                        <Input placeholder="17 znakov" maxLength={17} />
                      </Form.Item>
                    </Col>
                  </Row>

                  <Row gutter={15}>
                    <Col md={24} sm={24} xs={24}>
                      <Form.Item label={t("car.note")} name="note">
                        <Input placeholder="" />
                      </Form.Item>
                    </Col>
                  </Row>
                  <Row gutter={15}>
                    <Col md={24} sm={24} xs={24} style={{ marginTop: "20px" }}>
                      <Button
                        htmlType="submit"
                        size="default"
                        type="primary"
                        key="submit"
                      >
                        {t("car.addCar")}
                      </Button>
                    </Col>
                  </Row>
                </Form>
              </BasicFormWrapper>
            </AddUser>
          </div>
        </Modal>
      </Main>
    </>
  );
};

export default CarList;
